import { render, staticRenderFns } from "./DefaultBadges.vue?vue&type=template&id=d60b6ec0&scoped=true"
import script from "./DefaultBadges.vue?vue&type=script&lang=js"
export * from "./DefaultBadges.vue?vue&type=script&lang=js"
import style0 from "./DefaultBadges.vue?vue&type=style&index=0&id=d60b6ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60b6ec0",
  null
  
)

export default component.exports